import { Route, Routes } from "react-router-dom";
import { CavOfflineSyncList } from "./list";

export default function CavOfflineSyncRoutes() {
  return (
    <Routes>
      <Route path="/" element={<CavOfflineSyncList />} />
    </Routes>
  );
}
